import { useEffect, useRef } from "react"

//Assessments
import AssessmentFormQuestion from "./AssessmentFormQuestion"
import AssessmentFormGroupHeader from "./AssessmentFormGroupHeader"

//PrimeReact
import { Panel } from "primereact/panel"

//styling
import assessStyles from "../../../styles/assessments/Assessment.module.css"

export default function AssessmentFormGroup({
  group,
  answers,
  scores,
  readOnly,
  onSetFieldValue,
  displayAnswers,
  displayAnswerValues,
  displayScore,
}) {
  const groupRef = useRef(undefined)

  useEffect(() => {
    if (groupRef.current) {
      if (group.expanded === false) {
        groupRef.current.collapse()
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [groupRef])

  return (
    <Panel
      header={
        <AssessmentFormGroupHeader
          group={group}
          scores={scores}
          displayScore={displayScore}
        />
      }
      toggleable
      className={`${assessStyles.groupContainer}`}
      ref={groupRef}
    >
      <div
        className={
          group.alignment === "horizontal"
            ? assessStyles.groupContainerHorizontal
            : ""
        }
      >
        {group.questions.map((question) => {
          return (
            <AssessmentFormQuestion
              question={question}
              answers={answers}
              scores={scores}
              onSetFieldValue={onSetFieldValue}
              key={question.id}
              readOnly={readOnly}
              displayAnswers={displayAnswers}
              displayAnswerValues={displayAnswerValues}
              displayScore={displayScore}
            />
          )
        })}
      </div>
    </Panel>
  )
}
